/**
 * Created by esenckewitch on 18.07.2025
 */

const StickersCollection = function (options) {
    cleverapps.EventEmitter.call(this);

    this.isPrizeCollected = options.isPrizeCollected;
    this.isCompleted = false;

    this.index = options.index;
    this.season = options.season;

    this.createStickers(options);

    const [year, seasonIndex] = this.season.split("_");
    this.title = `Collection.${year}.season${seasonIndex}.collection${this.index}.Title`;
};

StickersCollection.prototype = Object.create(cleverapps.EventEmitter.prototype);
StickersCollection.prototype.constructor = StickersCollection;

StickersCollection.prototype.createStickers = function (options) {
    this.stickers = [];

    options.stickers.forEach((state, i) => {
        const [year, seasonIndex] = this.season.split("_");
        const title = `Sticker.${year}.season${seasonIndex}.collection${this.index}.sticker${i}.Title`;

        const sticker = new Sticker({
            collection: this,
            state,
            image: bundles[SeasonCollectionsHelper.getCollectionBundleName(this.index, this.season)].frames[`sticker_${i}_png`],
            rarity: this.calculateRarity(i),
            title,
            attention: i < options.attention.length ? options.attention[i] : false
        });
        sticker.on("update", this.onStickerUpdate.bind(this));
        this.stickers.push(sticker);
    });

    this.onStickerUpdate();
};

StickersCollection.prototype.getInfo = function () {
    return {
        isPrizeCollected: this.isPrizeCollected,
        stickers: this.stickers.map((sticker) => sticker.getState())
    };
};

StickersCollection.prototype.onPrizeCollect = function () {
    this.isPrizeCollected = true;
    cleverapps.stickersBook.save();
    this.trigger("update");
};

StickersCollection.prototype.onStickerUpdate = function () {
    let isCompleted = true;

    for (let i = 0; i < this.stickers.length; i++) {
        if (StickersBook.isPuzzle() && this.stickers[i].hasAttention()) {
            isCompleted = false;
        }

        if (this.stickers[i].getState() === Sticker.STATE_CLOSED) {
            isCompleted = false;
        }
    }

    if (isCompleted) {
        this.setCompleted();
    }

    this.trigger("update");
};

StickersCollection.prototype.setCompleted = function () {
    this.isCompleted = true;
    this.trigger("complete");
};

StickersCollection.prototype.getOpenedStickersAmount = function (withoutAttention) {
    return this.stickers.filter((sticker) => {
        if (StickersBook.isPuzzle() && !withoutAttention) {
            return sticker.getState() === Sticker.STATE_OPENED && !sticker.hasAttention();
        } 
        return sticker.getState() === Sticker.STATE_OPENED;
    }).length;
};

StickersCollection.prototype.isAvailable = function () {
    return true;
};

StickersCollection.prototype.isCollected = function () {
    return this.getOpenedStickersAmount(true) === StickersCollection.STICKERS_IN_COLLECTION;
};

StickersCollection.prototype.hasAttention = function () {
    return this.stickers.filter((sticker) => sticker.hasAttention()).length;
};

StickersCollection.prototype.getAttentionInfo = function () {
    return this.stickers.map((sticker) => sticker.hasAttention());
};

StickersCollection.prototype.updateAttention = function (data) {
    this.stickers.forEach((sticker, index) => {
        sticker.setAttention(data[index]);
    });
};

StickersCollection.prototype.resetAttention = function () {
    this.stickers.forEach((sticker) => {
        sticker.setAttention(false);
    });
    this.trigger("hideAttention");
};

StickersCollection.prototype.calculateRarity = function (stickerIndex) {
    let cumulativeRarity = 0;
    let result = 0;
    for (let i = 0; i < StickersCollection.COLLECTION_CONFIG[this.index].length; i++) {
        cumulativeRarity += StickersCollection.COLLECTION_CONFIG[this.index][i];
        if (stickerIndex < cumulativeRarity) {
            result = i;
            break;
        }
    }
    return result;
};

StickersCollection.getCollectionBundle = function (index, season) {
    return SeasonCollectionsHelper.getCollectionBundleName(index, season);
};

StickersCollection.STICKERS_IN_COLLECTION = 9;

StickersCollection.REGULAR_POINTS = 5;
StickersCollection.RARE_POINTS = 25;
StickersCollection.GOAL_POINTS = 200;

StickersCollection.RARITIES = [0, 1, 2, 3, 4, 5];
StickersCollection.DROP_PROBABILITIES = [0.3, 0.25, 0.2, 0.12, 0.08, 0.05];

StickersCollection.RARE_STICKERS_CONFIG = [
    3,
    4,
    4,
    3,
    4,
    3,
    5,
    4,
    5,
    5
];

StickersCollection.COLLECTION_CONFIG = [
    [7, 2, 0, 0, 0, 0],
    [7, 1, 1, 0, 0, 0],
    [5, 3, 1, 0, 0, 0],
    [3, 4, 1, 1, 0, 0],
    [2, 4, 1, 1, 1, 0],
    [1, 3, 2, 1, 1, 1],
    [0, 3, 2, 1, 2, 1],
    [0, 2, 2, 2, 1, 2],
    [0, 1, 3, 1, 2, 2],
    [0, 0, 3, 2, 1, 3],
    [0, 0, 2, 2, 2, 3],
    [0, 0, 0, 4, 2, 3]
];